export const SESSION_PROPERTY_KEYS = {
    phone: "phone",
    company: "company",
} as const;
